__turbopack_context__.v({
  "fullLayout": "cyQeZq_fullLayout",
  "minimalistHeader": "cyQeZq_minimalistHeader",
  "root": "cyQeZq_root",
});
